import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useTipoExtensaoDocumento = () => {
  const [tipoExtensaoDocumento, setTipoExtensaoDocumento] = useState<
    EnumOption[]
  >([]);

  useEffect(() => {
    const fetchTipoExtensaoDocumento = async () => {
      try {
        const response = await httpClient.get(
          `/api/documentossisdaf/enumTipoExtensaoDocumento`,
        );

        const options = response.data.map(
          (documento: { value: number; label: string }) => ({
            value: documento.value.toString(),
            label: documento.label,
          }),
        );
        setTipoExtensaoDocumento(options);
      } catch (error) {
        console.error('Erro ao buscar Tipos de Extensões de Documentos', error);
      }
    };

    fetchTipoExtensaoDocumento();
  }, []);

  return tipoExtensaoDocumento;
};
